import React, { useState, useContext, useEffect } from 'react';
import Panel from '../../../../components/Panel';
import useAPI from '../../../../hooks/useAPI';
import useErrors from '../../../../hooks/useErrors';
import AuthContext from '../../../../contexts/AuthContext';
import ComponentBusy from '../../../../components/ComponentBusy';

export default function ContractDetails({ onLoad, onLoadEnd }) {
  const { system } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);

  const api = useAPI();
  const errors = useErrors();

  const load = () => {
    onLoad();
    setLoading(true);

    api.json('GET', `/systems/${system.id}/contract-summary`)
      .then(r => r.json())
      .then((r) => {
        if (r.errors) {
          errors(r.errors);
          return;
        }

        const docList = [];
        if (r.data?.contract_uri) {
          docList.push({ label: 'Contract', uri: r.data.contract_uri });
        }
        if (r.data?.security_addendum_uri) {
          docList.push({ label: 'Security Addendum', uri: r.data.security_addendum_uri });
        }
        if (r.data?.terms_uri) {
          docList.push({ label: 'Terms & Conditions', uri: r.data.terms_uri });
        }
        if (r.data?.summary_uri) {
          docList.push({ label: 'Agreement Summary', uri: r.data.summary_uri });
        }

        setDocuments(docList);
      })
      .catch(() => setLoading(false))
      .finally(() => {
        onLoadEnd();
        setLoading(false);
      });
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return <ComponentBusy />;
  }

  return (
    <div className="account-settings">
      <Panel
        title="Contract Details"
        contentStyle={{ padding: 20 }}
        headerStyle={{
          borderBottomWidth: 1,
          borderStyle: 'solid',
          borderColor: '#E2E3E8',
          padding: 20,
        }}
      >
        <div className="row">
          <div className="col-12">
            {documents.length === 0 ? (
              <div style={{ display: 'flex', padding: 40, justifyContent: 'center', alignItems: 'center' }}>
                <span>Coming Soon</span>
              </div>
            ) : (
              documents.map(({ label, uri }, idx) => (
                <div key={idx} style={{ marginBottom: 40 }}>
                  <h5>{label}</h5>
                  <iframe
                    src={uri}
                    style={{ width: '100%', minHeight: 600 }}
                    title={`${label} Frame`}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </Panel>
    </div>
  );
}